import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { NvDesignLibraryModule } from '../../../../nvps-libraries/design/nv-design-library.module';
import { SharedServicesModule } from '../../services/shared.services.module';
import { NvMatTooltipModule } from '../nv-mat-tooltip/nv-mat-tooltip.module';
import { BatchActionsMenuComponent } from './batch-actions-menu.component';

@NgModule({
  declarations: [BatchActionsMenuComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    SharedServicesModule,
    NvMatTooltipModule,
    NvDesignLibraryModule,
  ],
  exports: [BatchActionsMenuComponent],
  providers: [],
  schemas: [],
})
export class BatchActionsMenuModule {}
